(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../utils/transitions"));
	else if(typeof define === 'function' && define.amd)
		define(["../../utils/transitions"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../utils/transitions")) : factory(root["../../utils/transitions"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__387__) {
return 